import { authHttp } from '../http'
import * as routes from '../../routes/checklist-operacional.routes'
import { errorHandler } from '../../../util/error.service'

export async function getPreenchimentos(tpId) {
  try {
    const { data } = await authHttp().get(routes.urlGetPreenchimentos(tpId))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getPreenchimentoFormInit(tpId) {
  try {
    const { data } = await authHttp().get(routes.urlGetPreenchimentoFormInit(tpId))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getPreenchimento(tpId, id) {
  try {
    const { data } = await authHttp().get(routes.urlGetPreenchimento(tpId, id))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function savePreenchimento(tpId, preenchimento) {
  try {
    const { data } = preenchimento.id
      ? await authHttp().put(routes.urlPutPreenchimento(tpId, preenchimento.id), preenchimento)
      : await authHttp().post(routes.urlPostPreenchimento(tpId), preenchimento)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveRespostas(tpId, id, respostas) {
  try {
    const { data } = await authHttp().put(routes.urlPutPreenchimentoRespostas(tpId, id), respostas)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function finalizarPreenchimento(tpId, id, respostas) {
  try {
    const { data } = await authHttp().post(
      routes.urlPostFinalizarPreenchimento(tpId, id),
      respostas,
    )
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deletePreenchimento(tpId, id) {
  try {
    const { data } = await authHttp().delete(routes.urlDeletePreenchimento(tpId, id))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}
